/**
 * User: nir
 * Date: 29/12/2016
 * Time: 18:12
 */

window.TCT = window.TCT || {};
window.TCT.TrackingUtils = {
    /*
     * Function to extract the Snowplow user ID from the first-party cookie set by the Snowplow JavaScript Tracker
     *
     * @param string cookieName (optional) The value used for "cookieName" in the tracker constructor argmap
     * (leave blank if you did not set a custom cookie name)
     *
     * @return string or bool The ID string if the cookie exists or false if the cookie has not been set yet
     */
    getSnowplowDuid: function (cookieName) {
        cookieName = cookieName || '_sp_';
        var matcher = new RegExp(cookieName + 'id\\.[a-f0-9]+=([^;]+);?');
        var match = document.cookie.match(matcher);
        if (match && match[1]) {
            return match[1].split('.')[0];
        } else {
            return false;
        }
    }
};